import { render, staticRenderFns } from "./ayuda.vue?vue&type=template&id=a64778ca&scoped=true&"
import script from "./ayuda.vue?vue&type=script&lang=js&"
export * from "./ayuda.vue?vue&type=script&lang=js&"
import style0 from "./ayuda.vue?vue&type=style&index=0&id=a64778ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64778ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardActions,VCardTitle,VDivider,VIcon,VList,VListItem,VListItemContent,VListItemIcon})
